import { FC, useState } from 'react'

import { Icon, IconName } from '../../components'
import { Button } from '../../components/Buttons'
import { downloadFile } from '../../helpers'
import { ExportCSVButtonProps } from './ExportCSVButtonProps'

import * as SC from './styles'

const DateInFileName = () => new Date().toLocaleDateString().replaceAll('/', ' ')

export const ExportCSVButton: FC<ExportCSVButtonProps> = (props) => {
  const { url, reportName, parametersForm, method } = props
  const [loading, setLoading] = useState(false)
  const filename = `${reportName} Report ${DateInFileName()}.csv`

  return (
    <Button
      face="secondary"
      loading={loading}
      onClick={() =>
        downloadFile({
          method,
          baseUrl: url,
          parametersForm,
          direct: true,
          mimeType: 'text/csv',
          name: filename,
          handleError: () => ({}),
          onStart: () => setLoading(true),
          onEnd: () => setLoading(false)
        })
      }
      data-qa={`${filename}-link`}
    >
      <SC.Container>
        <Icon name={IconName.DOWNLOAD} />
        Export CSV
      </SC.Container>
    </Button>
  )
}
